import { PropsWithChildren } from 'react';
import * as style from './FilterRow.css';

export const FilterRow: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={style.filters}>{children}</div>;
};

export const Filter: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={style.filter}>{children}</div>;
};
